import React from 'react';
import CancelIcon from '../Icons/CancelIcon'
const CancelButton = ({
    onClick,
    disabled,
    text,
    type
}) => {
    return (
        <div className="px-1">
            <button onClick={onClick} disabled={disabled} type={type} className="h-8 bg-red-800 text-gray-300 rounded hover:bg-red-700  hover:text-white shadow-md px-2 inline-flex items-center">
                <CancelIcon />
                <span className="px-1 pb-1 text-sm font-semibold">{text}</span>
            </button>
        </div>
    );
};

export default CancelButton;